import { createSelector } from '@ngrx/store';
import { ProfileStoreState } from './profile.state';


export namespace ProfileSelectors {
    const selectProfileStoreState = (state: { profile: ProfileStoreState }) => state.profile;

    export const selectAuthResponse = createSelector(selectProfileStoreState, ({ authResponse }: ProfileStoreState) => authResponse);
    export const selectAuthError = createSelector(selectProfileStoreState, ({ authError }: ProfileStoreState) => authError);
    export const selectProfile = createSelector(selectProfileStoreState, ({ profile }: ProfileStoreState) => profile);
}
